import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className="relative min-h-[calc(100vh-80px)] flex items-center justify-center py-20">
      {/* Animated background gradients */}
      <div className="absolute inset-0 bg-gradient-to-b from-deep-black via-deep-black/95 to-deep-black -z-10"></div>
      <div className="absolute -top-1/2 right-0 w-3/4 h-full bg-gradient-to-bl from-hot-pink/20 to-accent-purple/20 blur-3xl animate-float"></div>
      <div className="absolute -bottom-1/2 left-0 w-3/4 h-full bg-gradient-to-tr from-neon-blue/20 to-hot-pink/20 blur-3xl animate-float" style={{ animationDelay: '-3s' }}></div>

      <div className="container-custom">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-black mb-4 sm:mb-6">
            <span className="text-white">Angel & Devil</span>
            <br />
            <span className="text-gradient">Network</span>
          </h1>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-playfair mb-6 sm:mb-8">
            Where <span className="text-hot-pink">Temptation</span> Meets <span className="text-accent-purple">Talent</span>
          </h2>
          <p className="text-lg sm:text-xl text-white/80 max-w-2xl mx-auto mb-8 sm:mb-12 px-4">
            Deine Karriere in der Webcam-Branche beginnt hier! Als Full-Service-
            Agentur unterstützen wir dich dabei, dein volles Potenzial zu entfalten.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center px-4">
            <Link to="/bewerbung" className="btn-primary w-full sm:w-auto">JETZT STARTEN</Link>
            <Link to="/uber-uns" className="btn-secondary w-full sm:w-auto">MEHR ERFAHREN</Link>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 px-4">
          <div className="feature-card group">
            <h3 className="text-gradient text-xl sm:text-2xl font-playfair mb-4">Exklusives Netzwerk</h3>
            <p className="text-white/80 text-base sm:text-lg">
              Verbindungen zu den größten Plattformen wie Strip-Chat und myDirtyHobby.
            </p>
          </div>
          <div className="feature-card group">
            <h3 className="text-gradient text-xl sm:text-2xl font-playfair mb-4">Premium-Ausstattung</h3>
            <p className="text-white/80 text-base sm:text-lg">
              Kamera, Laptop, Licht und Toys – alles inklusive!
            </p>
          </div>
          <div className="feature-card group sm:col-span-2 lg:col-span-1">
            <h3 className="text-gradient text-xl sm:text-2xl font-playfair mb-4">Studio-Wohnnetzwerk</h3>
            <p className="text-white/80 text-base sm:text-lg">
              Voll ausgestattete Apartments für Multi-Streaming und Content-Creation.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
